var _g, _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinScribble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 44.2 26.153846",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_16)",
    id: "g57",
    transform: "rotate(9.871992,150.71204,-73.712118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 15.7505,19.4327 9.4419,37.6531 z",
    fill: "#b7b7b7",
    id: "path35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.7505,19.4327 9.4419,37.6531",
    stroke: "#b93160",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 52.6544,11.0501 9.4419,37.6531 z",
    fill: "#b7b7b7",
    id: "path39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 52.6544,11.0501 9.4419,37.6531",
    stroke: "#b93160",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.3111,10.6335 34.0372,14.8344 15.7633,19.0353",
    fill: "#b7b7b7",
    id: "path43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 52.3111,10.6335 34.0372,14.8344 15.7633,19.0353",
    stroke: "#b93160",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.8447,48.7082 25.7832,56.9939 Z",
    fill: "#b7b7b7",
    id: "path47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61.8447,48.7082 25.7832,56.9939",
    stroke: "#b93160",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.6951,31.6134 4.0768,18.1961 5.5512,-1.0396 -4.1576,-18.5603 z",
    stroke: "#b93160",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.8134,28.7085 c 1.7698,-0.3923 2.8679,-2.2285 2.4527,-4.1011 -0.4151,-1.8726 -2.1863,-3.0727 -3.9561,-2.6803 -1.7697,0.3923 -2.8678,2.2285 -2.4527,4.1011 0.4152,1.8726 2.1864,3.0727 3.9561,2.6803 z",
    stroke: "#b93160",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.1349,29.6946 4.2905,18.3875 5.4498,-1.3037 -2.6354,-11.1145 c 0.1495,-1.4629 0.4917,-2.8012 2.0888,-3.328 1.574,-0.4231 2.9826,-0.0441 3.8999,2.7166 l 2.2492,10.5316 5.5414,-1.2763 -2.9481,-12.5253 c -0.3714,-1.6563 -1.6163,-5.5773 -7.1279,-4.9138 -2.6899,0.3562 -4.0323,2.0156 -4.6921,4.335 l -0.6256,-2.8218 z",
    stroke: "#b93160",
    strokeWidth: 1.5,
    id: "path55"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "#ffffff",
    transform: "rotate(-12.5,71.146418,7.7918)",
    id: "rect59",
    x: 0,
    y: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinScribble);
export default __webpack_public_path__ + "static/media/linkedin_scribble.b77ff9cc9b86dc363dd82127b787cdaa.svg";
export { ForwardRef as ReactComponent };